module.exports = __webpack_public_path__ + "img/Dantam Fashion 12.46386b70.jpg";